<template>
  <f7-page class="setting-page-wrap page">
    <template v-if="backKey===true">
      

      
      <f7-navbar >
        <f7-nav-left style="padding-left:15px;">
           <i class="icon icon-back" @click="backIndex()" ></i>
        </f7-nav-left>
      </f7-navbar>
    </template>
    <template v-else>
      <f7-navbar   >
        <div style="width:100%;text-align:center;">
                 　
        </div>
      </f7-navbar>
    </template>
    <header class="wave-header sticky-top">
      <h2>推播資訊</h2>
    </header>
    
    <div class="list">
    <ul >
      <div v-for="(item,index) in approvedData.rows">

      
      <li class="item-content item-input">
      <div class="item-inner" style="width:180px">
      {{ item.createdAt.toString().split("T")[0]}}
      </div>
        <div class="item-inner">
          <div class="item-input-wrap">
            {{ item.pushContent }}
           
          </div>
        </div>
      </li>


      </div>





      
     
    </ul>

    </div>

  </f7-page>
</template>

<script>
import Service from "../../service";
import axios from '../../js/axiosModule.js';


export default {
  components: {
    
  },
  data() {
    return {
      approvedData:[],
      backKey:this.$f7route.query.back === undefined ? true : false,
    };
  },
  methods: {
  
 
    getInitData : function() {

      let self = this;
      var params = {};
      params.queryString = self.$store.state.userInfo.studentNo;

      axios.axiosTokenPost(self.$app.axiosUrl+"/api/PushNotification/GetPushNotificationRecordInfosByStudent",params).then((response) => {
            
        console.log(response.data);
         
        self.approvedData = response.data.data; 
      }).catch(err=>function() {
        
      });

    },
    backIndex : function() {
      let self = this;
      return new Promise((resolve,reject) => {
        self.$f7router.navigate("/");
        setTimeout(
          function() {
            bus.$emit('homeBus',{"avatarPath":self.localAavatarPath});
          }
        ,100);
      });
      
    }
  },
  mounted() {
 let self = this;
          self.getInitData();
  },
  created() {
          this.blockFlag = "none";
  },computed: {
    
  },
};


</script>



// WEBPACK FOOTER //
// src/pages/news/news.vue